export default "__VITE_ASSET__ca4ec594__"